module.exports = __webpack_public_path__ + "static/media/undraw_my_personal_files_8krs.a6f8090d.svg";